var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white w-screen h-9vh px-5vh shadow",attrs:{"id":"ht-header"}},[_c('div',{attrs:{"id":"logo"}},[_c('img',{attrs:{"src":_vm.Logo,"alt":""}})]),_c('div',{attrs:{"id":"clock"}},[_c('HtClock')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }